import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Panel } from '@/components/Panel';

export default function Account() {
  const [d, setD] = useState(null);
  const [form, setForm] = useState({ name: '', phone: '', address: '', clothing_size: 'M' });
  const [pw, setPw] = useState('');
  const [saved, setSaved] = useState('');

  useEffect(() => {
    (async () => {
      const { data } = await api.get('/founders/account');
      setD(data);
      setForm({
        name: data.user?.name || '',
        phone: data.user?.phone || '',
        address: data.user?.address || '',
        clothing_size: data.user?.clothing_size || 'M',
      });
    })();
  }, []);

  const save = async (e) => {
    e.preventDefault();
    await api.post('/founders/account', form);
    setSaved('Profile saved');
    setTimeout(() => setSaved(''), 2000);
  };

  const savePw = async (e) => {
    e.preventDefault();
    if (!pw || pw.length < 6) return;
    await api.post('/founders/password', { password: pw });
    setPw(''); setSaved('Password updated');
    setTimeout(() => setSaved(''), 2000);
  };

  if (!d) return <div style={{ color: 'var(--heritage-plum)' }}>Loading…</div>;

  return (
    <div className="space-y-6">
      <Panel className="p-8">
        <div className="h-eyebrow">My Account</div>
        <div className="h-display text-4xl mt-1" style={{ color: 'var(--heritage-plum)' }}>{d.user?.name}</div>
        <div className="opacity-80 mt-1 text-sm" style={{ color: 'var(--heritage-plum)' }}>{d.user?.email}</div>
      </Panel>

      <div className="grid md:grid-cols-2 gap-6">
        <Panel className="p-6">
          <div className="h-eyebrow mb-3">Personal details</div>
          <form onSubmit={save} className="space-y-3">
            <div><label className="h-label">Name</label><input className="h-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></div>
            <div><label className="h-label">Phone</label><input className="h-input" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} /></div>
            <div><label className="h-label">Address</label><input className="h-input" value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} /></div>
            <div>
              <label className="h-label">Clothing size</label>
              <select className="h-input" value={form.clothing_size} onChange={(e) => setForm({ ...form, clothing_size: e.target.value })}>
                {['XS','S','M','L','XL','XXL'].map(s => <option key={s}>{s}</option>)}
              </select>
            </div>
            <button className="h-btn" data-testid="account-save">Save</button>
          </form>
        </Panel>

        <div className="space-y-6">
          <Panel className="p-6">
            <div className="h-eyebrow mb-3">Membership</div>
            <div className="h-serif text-xl" style={{ color: 'var(--heritage-plum)' }}>{d.membership?.tier_name}</div>
            <div className="text-sm opacity-80" style={{ color: 'var(--heritage-plum)' }}>Founder {d.membership?.founder_number}</div>
            <div className="text-sm opacity-80" style={{ color: 'var(--heritage-plum)' }}>Since {(d.membership?.member_since || '').slice(0,10)}</div>
          </Panel>
          <Panel className="p-6">
            <div className="h-eyebrow mb-3">Change password</div>
            <form onSubmit={savePw} className="flex gap-2">
              <input className="h-input flex-1" type="password" minLength={6} value={pw} onChange={(e) => setPw(e.target.value)} placeholder="New password" />
              <button className="h-btn">Update</button>
            </form>
          </Panel>
        </div>
      </div>
      {saved && <div className="h-eyebrow" style={{ color: '#5B6E2C' }}>{saved}</div>}
    </div>
  );
}
